"use client";

import { createToggleContext } from "@/lib/createToggleContext";

const [ExtendedThinkingProvider, useExtendedThinkingRaw] =
  createToggleContext("extendedThinking");

export { ExtendedThinkingProvider };

export function useExtendedThinking() {
  const { extendedThinking, toggle, setThreadId } = useExtendedThinkingRaw();
  return { extendedThinking, toggleExtendedThinking: toggle, setThreadId };
}
